import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { createCandidate } from '../../store/slices/staffingSlice';
import Layout from '../../components/Layout';
import { STAFFING_CANDIDATE_STATUS } from '../../utils/constants';

const StaffingCandidateForm = () => {
  const { requirementId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [formData, setFormData] = useState({
    requirement_id: requirementId,
    name: '',
    skills: '',
    experience: '',
    salary: '',
    status: STAFFING_CANDIDATE_STATUS.INITIATED
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Convert comma-separated skills to array
      const submitData = {
        ...formData,
        skills: formData.skills.split(',').map(s => s.trim()).filter(s => s)
      };

      await dispatch(createCandidate(submitData)).unwrap();
      navigate(`/staffing/requirements/${requirementId}`);
    } catch (err) {
      setError(err.message || err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="container-fluid" style={{ maxWidth: '800px' }}>
        <button className="btn btn-outline-secondary mb-3" onClick={() => navigate(`/staffing/requirements/${requirementId}`)}>
          <i className="ti ti-arrow-left me-1" />
          Back to Requirement
        </button>

        <div className="card">
          <div className="card-body">
            <h2 className="fs-5 mb-3">Add New Candidate</h2>

            {error && <div className="alert alert-danger">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Full Name *</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter candidate name"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Skills *</label>
                <input
                  type="text"
                  name="skills"
                  className="form-control"
                  value={formData.skills}
                  onChange={handleChange}
                  placeholder="e.g., React, Node.js, AWS (comma-separated)"
                  required
                />
                <small className="text-muted d-block mt-1">
                  Enter skills separated by commas
                </small>
              </div>

              <div className="mb-3">
                <label className="form-label">Experience *</label>
                <input
                  type="text"
                  name="experience"
                  className="form-control"
                  value={formData.experience}
                  onChange={handleChange}
                  placeholder="e.g., 5 years"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Salary</label>
                <input
                  type="text"
                  name="salary"
                  className="form-control"
                  value={formData.salary}
                  onChange={handleChange}
                  placeholder="e.g., $60,000 per annum"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Status *</label>
                <select
                  name="status"
                  className="form-select"
                  value={formData.status}
                  onChange={handleChange}
                  required
                >
                  {Object.values(STAFFING_CANDIDATE_STATUS).map((status) => (
                    <option key={status} value={status}>
                      {status.replace(/_/g, ' ')}
                    </option>
                  ))}
                </select>
              </div>

              <div className="d-flex gap-2 justify-content-end mt-4">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => navigate(`/staffing/requirements/${requirementId}`)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Adding...' : 'Add Candidate'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default StaffingCandidateForm;
